/*
 * @Description: 引导页
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Mobile.vue'

const DiagnosisRouter: Array<RouteRecordRaw> = [
  {
    path: '/diagnosismoblie',
    component: Layout,
    redirect: '/diagnosis/index',
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "guide" */ '@/views/diagnosis-mobile/Index.vue'),
        name: 'DiagnosisMobile',
        meta: {
          title: 'diagnosis',
          icon: '#iconguide'
        }
      }
    ]
  }
]

export default DiagnosisRouter
